import {
  faCheck,
  faCircleInfo,
  faCopy,
} from "@fortawesome/pro-regular-svg-icons";
import { Button, Icon, Label, Tooltip } from "@intility/bifrost-react";
import { useState } from "react";

// One value in the client's details box: a label with an info icon that
// explains it, and the value with a button that copies it.
export function ClientDetailRow({
  label,
  hint,
  value,
}: {
  label: string;
  hint: string;
  value: string;
}) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div>
      <div className="client-detail-row-label">
        <Label>{label}</Label>
        <Tooltip content={hint}>
          <button
            type="button"
            className="client-detail-row-hint"
            aria-label={`About ${label}`}
          >
            <Icon icon={faCircleInfo} />
          </button>
        </Tooltip>
      </div>
      <div className="client-detail-row-value">
        <span>{value}</span>
        <Tooltip content={copied ? "Copied" : "Copy"}>
          <Button
            variant="flat"
            small
            className="client-icon-button"
            aria-label={`Copy ${label}`}
            onClick={copy}
          >
            <Icon icon={copied ? faCheck : faCopy} />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
}
